import { render, staticRenderFns } from "./DecimalPrice.vue?vue&type=template&id=3111755e&scoped=true"
import script from "./DecimalPrice.vue?vue&type=script&lang=js"
export * from "./DecimalPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3111755e",
  null
  
)

export default component.exports